import React, {useState, useEffect, useContext} from 'react';
import {Form, Input, InputGroup} from 'reactstrap';
import {confirmNewPassword, isTokenValid} from 'utils/api/authApi';
import {connect} from 'react-redux';
import {login, logoutWithoutRedirect} from 'redux/modules/auth/action';
import SpinnerButton from 'components/SpinnerButton';
import {useHistory} from 'react-router-dom';
import InputWithError from 'components/InputWithError';
import {ErrorContext} from 'contexts/ErrorContext';
import { toast } from 'react-toastify';

const NewPasswordPage = (props) => {
    let history = useHistory();
    const {handleErrors} = useContext(ErrorContext);

    const [checkingToken, setCheckingToken] = useState(true);
    const [passwordFirst, setFirstPassword] = useState('');
    const [passwordSecond, setSecondPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        checkToken();
    }, [])

    const checkToken = async() => {
        try {
            const href = window.location.href;
            const count = href.indexOf('token=');
            const token = href.substring(count).replace('token=', '');
            let tokenCheck = await isTokenValid(token);
            if(!tokenCheck.content.token) {
                // setTokenInvalid(true);
                history.push('/link-expired');
            }
            setCheckingToken(false);
        } catch(err) {
            console.log(err);
            // setCheckingToken(false);
            history.push('/404')
        }
    };

    const validation = (value, type) => {
        if(value.split('')[0] === ' ' || value.split('')[value.length - 1] === ' ') {
            return false;
        }

        if(type === 'first') {
            setFirstPassword(value);
        } else {
            setSecondPassword(value);
        }
    };

    const handleSubmit = async() => {
        const href = window.location.href;
        const count = href.indexOf('token=');
        const token = href.substring(count).replace('token=', '');

        try {
            setSubmitting(true);
            const params = {
                token,
                plainPassword: {
                    first: passwordFirst,
                    second: passwordSecond,
                },
            };
            const user = await confirmNewPassword(params);
            await props.login(user.content.email, passwordFirst);
            toast.success('Password successfully updated')
            history.push('/home');
            setSubmitting(false);
        } catch(err) {
            setSubmitting(false);
            handleErrors(err, setError);
            console.log(err);
        }
    };

    if(checkingToken) return null;
    return (
        <div className="d-flex flex-column justify-content-center align-items-center"
             style={{height: 'calc(100vh - 100px)', width: '100%'}}>
            <div className="d-flex flex-column p-4 authorization-container">
                <h3 className="align-self-center mb-2" style={{fontWeight: '700', fontFamily: 'Sans-serif'}}>
                    Reset Password
                </h3>
                <p className="align-self-center mb-3 text-center">
                    Enter your new password below <br/> (Minimum 6 Characters)
                </p>
                <div>
                    <InputWithError
                        placeholder="Password"
                        name="password"
                        value={passwordFirst}
                        type="password"
                        onChange={setFirstPassword}
                        errorObj={error}
                        prependIcon={<i className="fas fa-unlock-alt"/>}
                        marginBottomClass="mb-3"
                        // onPressEnter={handleSubmit}
                    />
                    <InputWithError
                        placeholder="Confirm Password"
                        name="plainPassword"
                        value={passwordSecond}
                        type="password"
                        onChange={setSecondPassword}
                        errorObj={error}
                        prependIcon={<i className="fas fa-unlock-alt"/>}
                        marginBottomClass="mb-3"
                        // onPressEnter={handleSubmit}
                    />
                    <div className="d-flex flex-column align-self-start">
                        <SpinnerButton
                            submitting={submitting}
                            onClick={handleSubmit}
                            title="Submit"
                            disabled={passwordFirst === '' || passwordSecond === ''}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};


const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateToProps,
    {login, logoutWithoutRedirect},
)(NewPasswordPage);
